import * as Yup from 'yup';
const passwordRegEx = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[[\]@_!#$%^&*()<>?/\|}{~:])[a-zA-Z\d\w\W]{8,20}$/g;
const numberRegEx = /^[0-9]+$/;

export const changePasswordFormSchema = Yup.object().shape({
  oldPassword: Yup.string()
    .min(8, 'Must be Minimum 8 characters')
    .required('Old Password is required'),
  newPassword: Yup.string()
    .min(8, 'Must be Minimum 8 characters')
    .notOneOf(
      [Yup.ref('oldPassword')],
      'New password cannot be as same as old password'
    )
    .required('New Password is required')
    .matches(passwordRegEx, 'Not a valid Password'),
  confirmPassword: Yup.string()
    .min(8, 'Must be Minimum 8 characters')
    .oneOf([Yup.ref('newPassword')], 'Password Should be same')
    .required('Confirm Password is required'),
});

export const updateAccountFormSchema = Yup.object().shape({
  accountName: Yup.string()
    .min(4, 'Must be Minimum 4 characters')
    .required('Account Name is Required'),
});
export const achPaymentFormSchema = Yup.object().shape({
  accountNumber: Yup.string()
    .required('Account Number is required')
    .matches(numberRegEx, 'Please Enter a Valid Account Number')
    .max(17, 'Account number must be at most 17 characters'),
  routingNumber: Yup.string()
    .required('Routing Number is required')
    .matches(numberRegEx, 'Please Enter a Valid Routing Number')
    .max(9, 'Routing number must be at most 9 characters'),
  bankName: Yup.string().max(30, 'Bank name must be at most 30 characters'),
});
